import { camelizeKeys } from "humps";
import { HQ_SERVICE } from "app_constants";
import { checkStatus, getRequest, parseJSON } from "helpers/requests";

export function getFeatureFlags() {
  return fetch(`${HQ_SERVICE}/super_users/features`, getRequest())
    .then(checkStatus)
    .then(parseJSON) as Promise<string[]>;
}

export interface IFeatureFlagMerchant {
  name: string;
  salesforceId: string;
  hqKey: string | null;
}

export interface IFeatureFlagMerchantStatuses {
  enabled: IFeatureFlagMerchant[];
  disabled: IFeatureFlagMerchant[];
}

export function getFeatureFlagStatus(featureName: string) {
  return fetch(
    `${HQ_SERVICE}/super_users/features/${featureName}`,
    getRequest()
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys) as Promise<IFeatureFlagMerchantStatuses>;
}
